module.exports = __webpack_public_path__ + "static/media/lysithea-vonordelia.ee83db18.png";